import { IOrderingTopListState } from '../../../models/ITopListState';
import { IActionPayload } from '../../../models/redux/IActionPayload';
import { DashboardActions } from '../../actions';
import { PERIOD_TYPE, TOP_LIST_ORDER } from '../../constants/constants';
import { PeriodHelper } from '../../utils/PeriodHelper';
import { ReduxHelper } from '../../utils/ReduxHelper';

const INITIAL_TOPLIST_BY_PNL_STATE: IOrderingTopListState = {
  isFetched: false,
  isFetching: false,
  cancelTokenSource: null,
  error: null,
  data: [],
  order: { name: TOP_LIST_ORDER.TABLE_COLUMN, direction: 'DESC' },
  period: { ...PeriodHelper.getPeriod(PERIOD_TYPE.INCEPTION), type: PERIOD_TYPE.INCEPTION },
};

const topListByPnLDefault = ReduxHelper.createHttpRequestReducer<IOrderingTopListState>(
  INITIAL_TOPLIST_BY_PNL_STATE,
  DashboardActions.TOPLIST_BY_PNL_REQUEST,
  DashboardActions.TOPLIST_BY_PNL_SUCCESS,
  DashboardActions.TOPLIST_BY_PNL_ERROR,
  DashboardActions.TOPLIST_BY_PNL_RESET
);

const topListByPnlReducer = (state = INITIAL_TOPLIST_BY_PNL_STATE, action: IActionPayload) => {
  switch (action.type) {
    case DashboardActions.TOPLIST_BY_PNL_CHANGE_ORDER: {
      return {
        ...state,
        order: action.payload,
      };
    }
    case DashboardActions.TOPLIST_BY_PNL_CHANGE_PERIOD: {
      return {
        ...state,
        period: action.payload,
      };
    }
    default:
      return topListByPnLDefault(state, action);
  }
};

export default topListByPnlReducer;
